module.exports = __webpack_public_path__ + "img/emotion-customization.10c3ce2.jpg";